export default __webpack_public_path__ + "static/media/Flowers01.352614ea.jpg";